import React from 'react';

export default {
    fields: [
        {
            type: 'checkbox',
            name: 'fieldNames',
            required: true,

            props: {

            }
        }
    ]
}


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/leadGenFieldPickerFormConfig.js